import { useMemo } from 'react';
import { BASE_FIELDS } from '../../common/constants';
import { useBoardFilters as useBoardFiltersOld } from '../../services/board-filters-old';
import { useBoardStore } from '../../services/board-store';
import { useSelectedFields } from '../fields-preference';
import { useGroupByFieldOld } from '../group-by';

const emptyArray: Array<number> = [];

/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */
export const useFieldIds = (includeBaseFields: boolean) => {
	const selectedFields = useSelectedFields();
	const [{ issueFields }] = useBoardStore();
	const groupByField = useGroupByFieldOld();
	const { filteredFieldIds } = useBoardFiltersOld();

	return useMemo(
		() =>
			Object.keys(issueFields ?? emptyArray)
				.filter(
					(fieldId) =>
						(selectedFields[fieldId] ||
							filteredFieldIds?.includes(fieldId) ||
							groupByField === fieldId) &&
						(includeBaseFields || !BASE_FIELDS.includes(fieldId)),
				)
				.map((fieldId) => {
					// Workaround to get epiclinks working for CMP projects again. Should be removed, revisited once
					// https://team.atlassian.com/project/ATLAS-11451 is complete
					if (
						issueFields &&
						issueFields[fieldId].type === 'com.pyxis.greenhopper.jira:gh-epic-link'
					) {
						return 'epiclink';
					}
					return fieldId;
				}),
		[filteredFieldIds, groupByField, includeBaseFields, issueFields, selectedFields],
	);
};
